import { useTrendingNiches } from "queries";
import { NicheListWidgetAlive } from "components/widgets/NicheListWidgetAlive";
import { INiche } from "services/types";
import { routes } from "routes";
import React from "react";

interface ITrendingNichesProps {
  listSize?: number;
}

export const TrendingNiches: React.FC<ITrendingNichesProps> = (props) => {
  const niches = useTrendingNiches();

  if (niches.isError) {
    return <p>Error loading niches.</p>;
  }

  const items = niches.data ? niches.data.map((el: INiche) => ({
    id: el.id,
    name: el.name,
    image: el.thumbnail,
    subscribers: el.subscribers,
  })) : [];

  return (
    <NicheListWidgetAlive
      className="trendingNiches"
      title="🔥️ Trending Niches"
      link={routes.niches()}
      niches={items}
      page={1}
      listSize={props.listSize}
    />
  );
};
